import { DataTable, EmptyState, type Spalte } from '../../muster';

/**
 * Die Planungsabschnitte — Sektoren um den Mittelpunkt, keine achsparallelen
 * Schnitte, ausgezählt und nicht angenommen.
 */
export function Planungsabschnitte({ bereiche }: { bereiche: any[] }) {
  const spalten: Spalte<any>[] = [
    {
      schluessel: 'abschnitt', titel: 'Abschnitt', immerSichtbar: true,
      wert: (b) => b.kennzeichen,
    },
    { schluessel: 'quadrant', titel: 'Quadrant', wert: (b) => b.quadrant },
    {
      schluessel: 'von', titel: 'von', art: 'zahl', einheit: '°', breite: '110px',
      wert: (b) => b.winkelVonGrad,
    },
    {
      schluessel: 'bis', titel: 'bis', art: 'zahl', einheit: '°', breite: '110px',
      wert: (b) => b.winkelBisGrad,
    },
    {
      schluessel: 'oeffnung', titel: 'Öffnung', art: 'zahl', einheit: '°',
      breite: '120px',
      wert: (b) => b.oeffnungGrad,
    },
    {
      schluessel: 'geschosse', titel: 'Geschosse', art: 'zahl', breite: '130px',
      wert: (b) => (b.geschosse ?? '').split(',').filter(Boolean).length,
    },
  ];

  return (
    <DataTable
      name="Planungsabschnitte"
      beschreibung={'Ausgezählt, nicht angenommen: Die sechs Abschnitte sind SEKTOREN '
        + 'um den Mittelpunkt, keine achsparallelen Schnitte. Nord und Nord-Ost '
        + 'überlappen in beiden Achsen — ein Achsvergleich könnte sie nicht trennen. '
        + 'Und sie sind nicht gleich groß; sie folgen dem Bauwerk.'}
      spalten={spalten}
      zeilen={bereiche ?? []}
      schluessel={(b) => b.kennzeichen}
      suche={false}
      ausfuhr
      leer={(
        <EmptyState
          titel="Kein Planungsabschnitt bestimmt."
          erklaerung={'Die Abschnitte entstehen aus den Flächenplänen des Modells und '
            + 'brauchen einen Koordinationslauf.'}
        />
      )}
    />
  );
}
